module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_pdv-48px"
  }, [_vm._m(0), _vm._v(" "), _c('p', {
    staticClass: "_mgbt-16px _fs-5"
  }, [_vm._v("\n        Breadcrumb ใช้สำหรับแสดงโครงสร้างการ Navigation ในหน้าปัจจุบัน\n      ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('hr', {
    staticClass: "_opct-30 _mgbt-32px"
  }), _vm._v(" "), _c('div', {
    staticClass: "_dp-f _jtfct-spbtw"
  }, [_c('div', [_c('h5', {
    staticClass: "_mgbt-16px"
  }, [_vm._v("ก่อนหน้า")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentAccordion'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-long-arrow-left _fs-5"
  }), _vm._v("  Accordion\n          ")])], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "_mgbt-16px _tal-r"
  }, [_vm._v("ต่อไป")]), _vm._v(" "), _c('router-link', {
    staticClass: "bio-link -fancy _pd-8px _bdrd-2px _fs-5",
    attrs: {
      "to": {
        name: 'ComponentButton'
      }
    }
  }, [_vm._v("\n            Button   "), _c('i', {
    staticClass: "fa fa-long-arrow-right _fs-5"
  })])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "_fs-2 _fw-600 _lh-150pct _mgbt-16px"
  }, [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#component-breadcrumb"
    }
  }, [_c('strong', [_vm._v("#")])]), _vm._v(" Breadcrumb\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-64px _fs-5"
  }, [_vm._v("\n        เราแนะนำให้คุณ ใช้ Class นี้บน "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<ul>")]), _vm._v(" และ ใช้ "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v("<li>")]), _vm._v("\n        เป็น List ของ Breadcrumb เพื่อความเหมาะสม\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Class ที่เกี่ยวข้อง")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "_mgbt-64px _fs-5 _lh-175pct _pdl-16px"
  }, [_c('li', [_vm._v("• "), _c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-breadcrumb")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("Options")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "bio-table _mgbt-64px"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "_w-1px"
  }, [_vm._v("Class")]), _vm._v(" "), _c('th', [_vm._v("Option")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', [_c('code', {
    staticClass: "_cl-accent"
  }, [_vm._v(".bio-breadcrumb")])])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                -\n              ")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งาน Breadcrumb")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<ul class=\"bio-breadcrumb\">\n  <li>Home</li>\n  <li>item</li>\n</ul>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('ul', {
    staticClass: "bio-breadcrumb"
  }, [_c('li', [_vm._v("Home")]), _vm._v(" "), _c('li', [_vm._v("Item")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "_mgbt-8px _fs-5"
  }, [_c('strong', [_vm._v("ตัวอย่างการใช้งานร่วมกับ")]), _vm._v(" "), _c('code', {
    staticClass: "language-markup _cl-accent"
  }, [_vm._v(".bio-link")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    staticClass: "example"
  }, [_c('code', {
    staticClass: "language-markup"
  }, [_vm._v("<ul class=\"bio-breadcrumb\">\n  <li><a class=\"bio-link\" href=\"#\">Home</a></li>\n  <li><a class=\"bio-link -primary\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -primary -fancy\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -positive\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -positive -fancy\" href=\"#\">Category</a></li>\n  <li><a class=\"bio-link -negative\" href=\"#\">Category</a></li>\n  <li>item</li>\n</ul>")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "u-panel _mgbt-64px"
  }, [_c('ul', {
    staticClass: "bio-breadcrumb"
  }, [_c('li', [_c('a', {
    staticClass: "bio-link",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Home")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -primary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -primary -fancy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -positive",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -positive -fancy",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "bio-link -negative",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Category")])]), _vm._v(" "), _c('li', [_vm._v("item")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b8ef422","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/document-pages/ComponentBreadcrumb.vue
// module id = 134
// module chunks = 0